import { TAO_KOE } from './../libs';

class FormConditional {
	dependencies = {};

	constructor( formEl ) {
		this.formEl = formEl;
		this.setup();
	}

	setup() {
		this.formEl.querySelectorAll( '[data-show-if]' ).forEach( ( conditionalEl ) => {
			const name = conditionalEl.getAttribute( 'data-show-if' );
			this.dependencies[ name ] ??= [];
			this.dependencies[ name ].push( [ conditionalEl, conditionalEl.getAttribute( 'data-show-if-value' ) ] );
		} );

		this.formEl.addEventListener( 'change', ( ev ) => this.onUpdate( ev.target ) );
		this.formEl.addEventListener( 'reset', () => this.onReset() );
	}

	onUpdate( inputEl ) {
		const name = inputEl.name;
		const type = inputEl.type;
		if ( 'undefined' !== typeof this.dependencies[ name ] ) {
			const inputValue = [ 'checkbox', 'radio' ].includes( type ) ? inputEl.checked : inputEl.value;
			this.dependencies[ name ].forEach( ( [ conditionalEl, value ] ) => {
				const isActive = value ? value === inputValue : Boolean( inputValue );
				conditionalEl.classList.toggle( 'en_hidden', ! isActive );
				conditionalEl.querySelectorAll( 'input, select, textarea' ).forEach( ( innerInputEl ) => {
					innerInputEl.disabled = ! isActive;
				} );
			} );
		}
	}

	onReset() {
		const inputEls = Array.from( this.formEl.elements );
		setTimeout( () => inputEls.forEach( ( inputEl ) => this.onUpdate( inputEl ) ), 10 );
	}

	static init( scopeEl = document ) {
		const formEls = Array.from( scopeEl.getElementsByClassName( 'form--default' ) ).filter( ( formEl ) => formEl.matches( 'form.form--default:has([data-show-if])' ) );
		formEls.forEach( ( formEl ) => {
			formEl.KOE_FORM_CONDITIONAL ??= new FormConditional( formEl );
		} );
	}
}

// Init.
TAO_KOE.ready( 'form-conditional.js', () => FormConditional.init() );

// Export.
export default FormConditional;
